import { render, staticRenderFns } from "./RegisterPromo.vue?vue&type=template&id=167823ab&scoped=true&"
import script from "./RegisterPromo.vue?vue&type=script&lang=js&"
export * from "./RegisterPromo.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPromo.vue?vue&type=style&index=0&id=167823ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167823ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
